import { FC, memo } from 'react';
import { Table } from 'shared/ui/Table';
import { UnFormalizedZipListItem } from 'entities/unFormalizedZip';
import { UNFORMALIZED_ZIP_TABLE_COLUMNS } from '../../constants/unFormalizedZipConstants';

interface UnFormalizedZipTableProps {
  items: UnFormalizedZipListItem[];
  onEdit: (item: UnFormalizedZipListItem) => void;
  onDelete: (id: number) => void;
  onFormalize: (item: UnFormalizedZipListItem) => void;
}

export const UnFormalizedZipTable: FC<UnFormalizedZipTableProps> = memo(({
  items, onEdit, onDelete, onFormalize,
}) => {
  const actions = [
    {
      key: 'formalize',
      label: 'Формализовать',
      onClick: (record: UnFormalizedZipListItem) => onFormalize(record),
    },
    {
      key: 'edit',
      label: 'Редактировать',
      onClick: (record: UnFormalizedZipListItem) => onEdit(record),
    },
    {
      key: 'delete',
      label: 'Удалить',
      onClick: (record: UnFormalizedZipListItem) => onDelete(record.id as number),
      danger: true,
    },
  ];

  return (
    <Table
      columns={UNFORMALIZED_ZIP_TABLE_COLUMNS}
      dataSource={items}
      rowKey="id"
      hasPagination
      actions={actions}
      enableFullTableSearch
      enableClearFilters
      onRowDoubleClick={(record: UnFormalizedZipListItem) => onFormalize(record)}
    />
  );
});

UnFormalizedZipTable.displayName = 'UnFormalizedZipTable';
